import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
export default {
  name: "APIConfig",
  props: {
    config: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      options: [{
        value: "get",
        label: "get"
      }, {
        value: "post",
        label: "post"
      }, {
        value: "delete",
        label: "delete"
      }, {
        value: "put",
        label: "put"
      }, {
        value: "connect",
        label: "connect"
      }]
    };
  },
  methods: {
    addMsg: function addMsg() {
      this.config.push({
        isLog: 0,
        isRemoteCall: 0,
        method: "",
        name: "",
        url: ""
      });
    },
    delBtn: function delBtn(e) {
      this.config.splice(e, 1);
    }
  }
};